global.unitList = global.API_ADMIN_URL+'unitList/';
global.adminAddUnit = global.API_ADMIN_URL+'adminAddUnit/';
global.adminEditUnit = global.API_ADMIN_URL+'adminEditUnit/';
global.unitDetails = global.API_ADMIN_URL+'unitDetails/';
global.adminUnitStatus = global.API_ADMIN_URL+'adminUnitStatus/';